// if you change this constant please verify once in reports practitioner(patient) table.
export const TAB_HEAD = [
    { value: 'NEW', label: 'New' },
    { value: 'CONSULTATION_BOOKED', label: 'Consultation booked' },
    { value: 'CONSULTATION_ATTENDED', label: 'Consultation attended' },
    { value: 'TREATMENT_STARTED', label: 'Treatment started' },
    { value: 'FAILED_TO_ATTEND_CONSULTATION', label: 'FTA' },
    { value: 'CLOSED', label: 'Completed' }
];

export const inputKeys = ['Backspace', 'Tab', 'ArrowRight', 'ArrowLeft', '+'];
export const targetInputs = ['Backspace', 'Tab', 'ArrowRight', 'ArrowLeft'];
export const userInputs = ['Backspace', 'Tab', 'ArrowRight', 'ArrowLeft', ' '];

// past Appointment
export const tableLabels = [
    { id: 'Date', label: 'Date', align: 'left' },
    { id: 'Time', label: 'Time', align: 'left' },
    { id: 'Treatment', label: 'Treatment', align: 'left' },
    { id: 'Type', label: 'Type', align: 'left' },
    { id: 'Practitioner', label: 'Practitioner', align: 'left' },
];

// upcoming Appointment
export const upcomingTableLabels = [
    { id: 'Date', label: 'Date', align: 'left' },
    { id: 'Time', label: 'Time', align: 'left' },
    { id: 'Treatment', label: 'Treatment', align: 'left' },
    { id: 'Method', label: 'Method', align: 'left' },
    { id: 'Type', label: 'Type', align: 'left' },
    { id: 'Practitioner', label: 'Practitioner', align: 'left' },
    { id: 'Status', label: 'Status', align: 'left' },
    { id: '' },
];

export const upcomingAppointmentsLabels = [
    { id: 'Date', label: 'Date & Time', align: 'left' },
    { id: 'Treatment', label: 'Treatment', align: 'left' },
    { id: 'Practitioner', label: 'Practitioner', align: 'left' },
    { id: '' },
];

export const archiveAppointmentsLabels = [
    { id: 'Date', label: 'Date & Time', align: 'left' },
    { id: 'Treatment', label: 'Treatment', align: 'left' },
    { id: 'Practitioner', label: 'Practitioner', align: 'left' },
    { id: 'Status', label: 'Status', align: 'left' },
];

export const Channel = [
    { name: 'New Email', value: 'EMAIL' }
];

export const CreateLeadHeaderData = {
    title: 'Create Lead',
    button1: 'Save & Continue Later',
    button2: 'Close',
};

export const CreateCampaignHeaderData = {
    title: 'Create Campaign',
    button1: 'Save & Continue Later',
    button2: 'Close',
};

export const statuses = ['NEW', 'CONSULTATION_ATTENDED', 'ATTENDED', 'FAILED_TO_ATTEND_CONSULTATION', 'FAILED_TO_ATTEND'];

// task reminder
export const TASK_TAB_HEAD = [
    { value: '', label: 'All tasks', icon: 'fluent:tasks-app-28-regular' },
    { value: 'TODO', label: 'Todo', icon: 'mdi:to-do' },
    { value: 'FOLLOW_UP', label: 'Follow up', icon: 'mdi:reply-outline' },
    { value: 'NEW_LEAD', label: 'New lead', icon: 'mdi:account-plus-outline' },
    { value: 'CALLBACK_REQUEST', label: 'Callback request', icon: 'mdi:call-to-action' },
    { value: 'UNANSWERED', label: 'Unanswered', icon: 'mdi:message-question-outline' },
    { value: 'OTHER', label: 'Other', icon: 'mdi:dots-horizontal' },
    // Lead-status counters retained for other UI areas that filter by lead status
    { value: 'NEW', label: 'Follow up (legacy)', icon: 'lucide:user-plus-2' },
    { value: 'CONSULTATION_BOOKED', label: 'Record attendance', icon: 'ph:calendar-minus-bold' },
    { value: 'CONSULTATION_ATTENDED', label: 'Consultation follow', icon: 'tabler:phone' },
    { value: 'TREATMENT_STARTED', label: 'Treatment started', icon: 'ph:caret-right-duotone' },
    { value: 'FAILED_TO_ATTEND_CONSULTATION', label: 'FTA', icon: 'eva:question-mark-circle-outline' },
    { value: 'CLOSED', label: 'Completed', icon: 'fluent-mdl2:completed' },
];

// Task type filter (task group only — no lead statuses)
export const TASK_TYPE_HEAD = [
    { value: '', label: 'All types', icon: 'fluent:tasks-app-28-regular' },
    { value: 'TODO', label: 'Todo', icon: 'mdi:to-do' },
    { value: 'FOLLOW_UP', label: 'Follow up', icon: 'mdi:reply-outline' },
    { value: 'NEW_LEAD', label: 'New lead', icon: 'mdi:account-plus-outline' },
    { value: 'CALLBACK_REQUEST', label: 'Callback', icon: 'mdi:call-to-action' },
    { value: 'UNANSWERED', label: 'Unanswered', icon: 'mdi:message-question-outline' },
    { value: 'OTHER', label: 'Other', icon: 'mdi:dots-horizontal' },
];

// Lead status filter (separate from task type)
export const LEAD_STATUS_HEAD = [
    { value: '', label: 'All statuses' },
    { value: 'NEW', label: 'New / Follow up' },
    { value: 'CONSULTATION_BOOKED', label: 'Consultation booked' },
    { value: 'CONSULTATION_ATTENDED', label: 'Consultation attended' },
    { value: 'TREATMENT_STARTED', label: 'Treatment started' },
    { value: 'FAILED_TO_ATTEND_CONSULTATION', label: 'Failed to attend' },
    { value: 'CLOSED', label: 'Completed' },
];


export const TASK_ADDITIONAL_FILTER = [
    { value: 'Today', label: 'Today' },
    { value: 'Upcoming', label: 'Upcoming' },
];

// notifications — legacy 6-event list (kept for backward compatibility)
export const ACTIVITY_OPTIONS = [
    {
        value: 'ASSIGNED_TO_LEAD',
        label: 'Notify me when someone assigns a lead to me.',
    },
    {
        value: 'ASSIGNED_TO_TASK',
        label: 'Notify me when someone assigns a task to me.',
    },
    {
        value: 'TASK_DUE_REMINDER',
        label: 'Notify me for overdue tasks.',
    },
    {
        value: 'TASK_OVERDUE_REMINDER',
        label: 'Notify me for task due.',
    },
    {
        value: 'DEPOSIT_PAID',
        label: 'Notify me for deposit paid.',
    },
    {
        value: 'NEW_LEAD',
        label: 'Notify me for new lead.',
    },
];

// ── Full 16-event notification system ──────────────────────────────
// Groups map to backend PracticeUserNotificationPreference events.
// Channels: PLATFORM (bell) and WHATSAPP (staff WhatsApp message).

export const NOTIFICATION_EVENTS = [
    // Lead notifications
    { event: 'NEW_LEAD',              label: 'New Lead',               description: 'When a new lead is created and no one is assigned',    category: 'Lead' },
    { event: 'ASSIGNED_TO_LEAD',      label: 'Assigned to Lead',       description: 'When you are assigned to a lead',                     category: 'Lead' },
    { event: 'UNASSIGNED_FROM_LEAD',  label: 'Unassigned from Lead',   description: 'When you are unassigned from a lead',                 category: 'Lead' },
    { event: 'LEAD_RESTORED',         label: 'Lead Restored',          description: 'When an archived lead is restored',                   category: 'Lead' },
    { event: 'LEAD_ARCHIVED',         label: 'Lead Archived',          description: 'When a lead you are assigned to is archived',          category: 'Lead' },
    // Task / Reminder notifications
    { event: 'ASSIGNED_TO_TASK',      label: 'Assigned to Task',       description: 'When a task or reminder is assigned to you',           category: 'Task' },
    { event: 'TASK_DUE_REMINDER',     label: 'Task Due Today',         description: 'When your task is due today',                         category: 'Task' },
    { event: 'TASK_OVERDUE_REMINDER', label: 'Task Overdue',           description: 'When your task is overdue',                           category: 'Task' },
    { event: 'CALLBACK_REQUEST',      label: 'Callback Request',       description: 'When a patient requests a callback',                  category: 'Task' },
    // Payment notifications
    { event: 'DEPOSIT_PAID',          label: 'Deposit Paid',           description: 'When a patient pays a deposit',                       category: 'Payment' },
    // Treatment notifications
    { event: 'LEAD_TREATMENT_STARTED',   label: 'Treatment Started',      description: 'When a treatment starts for a patient',            category: 'Treatment' },
    { event: 'TREATMENT_OFFER_EXPIRED',  label: 'Treatment Offer Expired', description: 'When a treatment offer expires',                  category: 'Treatment', comingSoon: true },
    // Forms notifications — corresponds to NOTIFICATION_EVENT_CHOICES
    // FORM_SUBMITTED + FORM_RESEND_REQUESTED on the backend. Both default
    // to ``is_available: false`` in notificationConfigStub (no FE auto-
    // enable) so admins flip them on per-practice from the Practice
    // Choices page; existing users without a preference row don't get
    // surprise notifications.
    { event: 'FORM_SUBMITTED',          label: 'Form Submitted',         description: 'When a patient submits a consent or medical history form', category: 'Forms' },
    { event: 'FORM_RESEND_REQUESTED',   label: 'New Form Link Requested', description: 'When a patient requests a fresh form link from the already-submitted screen', category: 'Forms' },
    // Communication notifications
    { event: 'WHATSAPP_MESSAGE',      label: 'WhatsApp Message',       description: 'When an inbound WhatsApp message is received',         category: 'Communication' },
    { event: 'EMAIL_REPLY',           label: 'Email Reply',            description: 'When a patient replies to an email',                   category: 'Communication' },
    { event: 'FACEBOOK_COMMENT',      label: 'Facebook Comment',       description: 'When someone comments on a Facebook post',             category: 'Communication' },
    // Other notifications
    { event: 'PHONE_NUMBER_CLICKED',  label: 'Phone Number Clicked',   description: 'When someone clicks the phone number on your website', category: 'Other' },
    { event: 'WHATSAPP_BUTTON_CLICKED', label: 'WhatsApp Button Clicked', description: 'When someone clicks the WhatsApp button on your website', category: 'Other' },
    { event: 'GMB_NEW_REVIEW',        label: 'Google Review',          description: 'When you get a new Google My Business review',         category: 'Other' },
];

export const NOTIFICATION_EVENT_CATEGORIES = ['Lead', 'Task', 'Payment', 'Treatment', 'Forms', 'Communication', 'Other'];

export const NOTIFICATION_CHANNELS = [
    { key: 'PLATFORM',  label: 'Bell',     icon: 'solar:bell-bing-bold-duotone',       description: 'In-app notifications' },
    { key: 'WHATSAPP',  label: 'WhatsApp',  icon: 'ic:baseline-whatsapp',               description: 'Staff WhatsApp messages' },
];

export const NOTIFICATION_PLATFORM = [
    'PLATFORM',
    'EMAIL',
    'SMS'
];

export const NOTIFICATION_SETTING_LABEL = [
    'ASSIGNED_TO_LEAD',
    'ASSIGNED_TO_TASK',
    'TASK_DUE_REMINDER',
    'TASK_OVERDUE_REMINDER',
    'DEPOSIT_PAID',
    'NEW_LEAD'
];

export const TABS = [
    {
        value: 'new',
        label: 'New',
    },
    {
        value: 'cleared',
        label: 'Cleared',
    },
];

export const attendedAppointmentsLabels = [
    { id: 'Date', label: 'Date & Time', align: 'left' },
    { id: 'Treatment', label: 'Treatment', align: 'left' },
    { id: 'Practitioner', label: 'Practitioner', align: 'left' },
    { id: 'Comment', label: 'Patient Feedback', align: 'left' },
    { id: '' },
];

export const pastApptTableLabels = [
    { id: 'Date', label: 'Date', align: 'left' },
    { id: 'Time', label: 'Time', align: 'left' },
    { id: 'Treatment', label: 'Treatment', align: 'left' },
    { id: 'Method', label: 'Method', align: 'left' },
    { id: 'Type', label: 'Type', align: 'left' },
    { id: 'Practitioner', label: 'Practitioner', align: 'left' },
    { id: 'Comment', label: 'Patient Feedback', align: 'left' },
    { id: 'Status', label: 'Status', align: 'left' },
    { id: '' },
];

// Journey lifecycle stages
export const JOURNEY_STAGES = [
    { value: 'NEW', label: 'Enquiry', color: '#3b82f6', icon: 'mdi:question-mark-circle-outline' },
    { value: 'CONSULTATION_BOOKED', label: 'Booked', color: '#f59e0b', icon: 'mdi:calendar-clock' },
    { value: 'CONSULTATION_ATTENDED', label: 'Attended', color: '#8b5cf6', icon: 'mdi:calendar-check' },
    { value: 'TREATMENT_STARTED', label: 'Treatment', color: '#00A76F', icon: 'codicon:debug-start' },
    { value: 'CLOSED', label: 'Complete', color: '#10b981', icon: 'material-symbols:check-circle-outline' },
];

export const JOURNEY_STAGE_ORDER = ['NEW', 'CONSULTATION_BOOKED', 'CONSULTATION_ATTENDED', 'TREATMENT_STARTED', 'CLOSED'];

export const getStageIndex = (status) => {
    const idx = JOURNEY_STAGE_ORDER.indexOf(status);
    return idx >= 0 ? idx : 0;
};

export const getMostAdvancedStatus = (treatments) => {
    if (!treatments || treatments.length === 0) return 'NEW';
    let maxIdx = 0;
    treatments.forEach((t) => {
        const idx = JOURNEY_STAGE_ORDER.indexOf(t.status);
        if (idx > maxIdx) maxIdx = idx;
    });
    return JOURNEY_STAGE_ORDER[maxIdx] || 'NEW';
};

export const NEXT_STEP_SUGGESTIONS = {
    // Patient just submitted a form (within last 24h). Takes precedence over NEW_NO_CONTACT
    // because chasing a lead who just acted feels wrong; the rep should review the submission.
    FORM_SUBMITTED_RECENT: {
        icon: 'eva:file-text-fill', color: '#00AB55', bgColor: 'rgba(0, 171, 85, 0.08)',
        getMessage: (formName, timeAgo) => `${formName || 'Form'} was submitted ${timeAgo || 'recently'}`,
        cta: 'Review submission', action: 'forms',
    },
    NEW_NO_CONTACT: {
        icon: 'mdi:phone-alert', color: '#FF5630', bgColor: 'rgba(255, 86, 48, 0.08)',
        getMessage: (days) => `This lead hasn't been contacted in ${days} day${days !== 1 ? 's' : ''}`,
        cta: 'Contact now', action: 'contact',
    },
    CONSULTATION_BOOKED_UPCOMING: {
        icon: 'mdi:calendar-alert', color: '#FFAB00', bgColor: 'rgba(255, 171, 0, 0.08)',
        getMessage: (days) => `Consultation in ${days} day${days !== 1 ? 's' : ''}`,
        cta: 'Send a reminder', action: 'communicate',
    },
    CONSULTATION_ATTENDED: {
        icon: 'mdi:file-document-edit-outline', color: '#8b5cf6', bgColor: 'rgba(139, 92, 246, 0.08)',
        getMessage: () => 'Consultation attended — follow up with treatment plan',
        cta: 'Follow up', action: 'followup',
    },
    TREATMENT_STARTED: {
        icon: 'mdi:account-check-outline', color: '#00A76F', bgColor: 'rgba(0, 167, 111, 0.08)',
        getMessage: () => 'Treatment in progress — check in with patient',
        cta: 'Check in', action: 'followup',
    },
    FAILED_TO_ATTEND: {
        icon: 'mdi:calendar-remove', color: '#FF5630', bgColor: 'rgba(255, 86, 48, 0.08)',
        getMessage: (days) => `Failed to attend — last attempt ${days} day${days !== 1 ? 's' : ''} ago`,
        cta: 'Rebook consultation', action: 'followup',
    },
};